import DashboardLayout from '@/layouts/DashboardLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { TransactionsRouteName } from '@/types/router/name/transactions';
import { TransactionsRoutePath } from '@/types/router/path/transactions';

export default [
    {
        path: TransactionsRoutePath.Transactions,
        name: TransactionsRouteName.Transactions,
        component: () => import('@/pages/transactions/index.vue'),
        meta: {
            group: 'transactions',
            title: 'Transactions',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
